import axios from "axios";

export class UtilNavigate {
  static loadEnsemblId = (
    id: string,
    type: string,
    props = {},
    target = "_self"
  ) => {
    axios
      .get(`https://mygene.info/v3/query?q=${id}&species=human`)
      .then((response) => {
        axios
          .get(`https://mygene.info/v3/gene/${response.data.hits[0]._id}`)
          .then((link) => {
            const parts = document.location.pathname.split("/").reverse();
            const gene =
              link.data.ensembl.length !== undefined
                ? link.data.ensembl[0].gene
                : link.data.ensembl.gene;
            // if (type === "protein") {
            //   UtilNavigate.To(type, gene + "/" + id);
            // } else {
            UtilNavigate.To(type, gene, props, target);
            // }
          });
      });
  };

  static Link = (entity: "gene" | "dataset", id: string): string => {
    return "";
  };

  // "gene" | "dataset" | "cell" | "motif"
  static To = (
    entity: string,
    id: string,
    props = {},
    target = "_self"
  ): void => {
    id = id.replace(/ /g, "_");
    id = id.replace(/\./gi, "_");
    if (entity.toLowerCase().trim().startsWith("chr")) {
      return;
    }
    if (entity.toLowerCase().trim() === "cell") {
      if (props.hasOwnProperty("linkCell")) {
        window.open(props.linkCell.replace("{cell}", id).toLowerCase(), target);
        return;
      }
    }

    if (entity.toLowerCase().trim().startsWith("dataset")) {
      window.open(
        props.linkDataset.replace("{dataset}", id).toLowerCase(),
        target
      );
      return;
    }
    if (entity.toLowerCase().trim() === "protein") {
      window.open(
        props.linkProtein.replace("{protein}", id).toLowerCase(),
        target
      );
      return;
    }
    if (entity.toLowerCase().trim() === "gene") {
      if (!id.toLowerCase().startsWith("ens")) {
        UtilNavigate.loadEnsemblId(id, "gene", props, target);
        return;
      }
      if (props.hasOwnProperty("linkGene")) {
        window.open(props.linkGene.replace("{gene}", id).toLowerCase(), target);
        return;
      }
    }
    if (entity.toLowerCase().trim() === "tissue") {
      if (props.hasOwnProperty("linkTissue")) {
        window.open(
          props.linkTissue.replace("{tissue}", id).toLowerCase(),
          target
        );
        return;
      }
    }
    if (entity.toLowerCase().trim() === "dataset") {
      if (props.hasOwnProperty("linkDataset")) {
        window.open(
          props.linkDataset.replace("{dataset}", id).toLowerCase(),
          target
        );
        return;
      }
    }
    if (entity.toLowerCase().trim() === "motif") {
      if (props.hasOwnProperty("linkMotif")) {
        window.open(
          props.linkMotif
            .replace("{motif}", id)
            .toLowerCase()
            .replace(/:/gi, ""),
          target
        );
        return;
      }
      id = id.replace(/\W/gi, "");
    }

    const parts = document.location.pathname.split("/");
    const atlas = parts[1];
    let dataset = parts[parts.length - 1];
    if (dataset === atlas) {
      dataset = "";
    }
    if (dataset !== "") {
      dataset = `in/${dataset}`;
    }
    const uri =
      entity === "dataset"
        ? `/${atlas}/dataset/${id}`
        : `/${atlas}/${entity}/${id.replace(/\s/gi, "_")}/${dataset}`;
    window.open(uri.toLowerCase(), target);
  };
}
